import React from 'react';

export default function OperationCell(cellData) {

    if (cellData.data.direction) {
        return (
            <div><span className="greenIcon dx-icon-arrowright"></span><div className="greenText">{cellData.value}</div></div>
        );
    }
    else {
        return (
            <div><span className="blueIcon dx-icon-arrowleft"></span>{cellData.value}</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/position/OperationCell.jsx